// Shared constants for the REST list endpoints.

// The largest `_limit` any list endpoint will honour. Every paginated route
// clamps with `Math.min(..., 10000)` server-side — mice.js, cages.js,
// litters.js, genetics.js (locus + allele) and strains.js — so asking for more
// is silently truncated, not an error. Call sites used to send 1000000 or
// 1000000000 interchangeably; both meant "give me everything" and both got
// 10000. Keep this in step with those clamps.
export const MAX_LIST_LIMIT = 10000;
